__turbopack_context__.v({
  "conversation-empty": "xwEpjq_conversation-empty",
  "conversation-list": "xwEpjq_conversation-list",
  "conversation-message": "xwEpjq_conversation-message",
  "conversation-meta": "xwEpjq_conversation-meta",
  "conversation-panel": "xwEpjq_conversation-panel",
  "conversation-preview": "xwEpjq_conversation-preview",
  "conversation-reply": "xwEpjq_conversation-reply",
  "conversation-toggle": "xwEpjq_conversation-toggle",
  "conversation-turn": "xwEpjq_conversation-turn",
  "steering-footer": "xwEpjq_steering-footer",
  "steering-heading": "xwEpjq_steering-heading",
  "steering-panel": "xwEpjq_steering-panel",
  "suggestions": "xwEpjq_suggestions",
});
